/**
 * Token 管理工具
 */

const TOKEN_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  ACCESS_TOKEN_EXPIRE: 'access_token_expire',
  REFRESH_TOKEN_EXPIRE: 'refresh_token_expire',
  USER_ID: 'user_id',
  IS_TAINTED: 'is_tainted',
};

/**
 * 保存登录信息
 * @param {object} data - 登录响应数据
 */
export function saveAuthData(data) {
  const { access_token, refresh_token } = data;

  if (access_token) {
    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, access_token.token);
    localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN_EXPIRE, access_token.expire_at);
  }

  if (refresh_token) {
    localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN, refresh_token.token);
    localStorage.setItem(TOKEN_KEYS.REFRESH_TOKEN_EXPIRE, refresh_token.expire_at);
  }
}

/**
 * 获取 Access Token
 * @returns {string|null} Access Token
 */
export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
}

/**
 * 获取 Refresh Token
 * @returns {string|null} Refresh Token
 */
export function getRefreshToken() {
  return localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN);
}

/**
 * 检查 Access Token 是否过期
 * @returns {boolean} 是否过期
 */
export function isAccessTokenExpired() {
  const expireAt = localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN_EXPIRE);
  if (!expireAt) return true;

  const now = Math.floor(Date.now() / 1000);
  return now >= parseInt(expireAt, 10);
}

/**
 * 检查 Refresh Token 是否过期
 * @returns {boolean} 是否过期
 */
export function isRefreshTokenExpired() {
  const expireAt = localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN_EXPIRE);
  if (!expireAt) return true;

  const now = Math.floor(Date.now() / 1000);
  return now >= parseInt(expireAt, 10);
}

/**
 * 检查用户是否已登录
 * @returns {boolean} 是否已登录
 */
export function isLoggedIn() {
  const accessToken = getAccessToken();
  if (!accessToken) return false;

  // 如果 access token 未过期，认为已登录
  if (!isAccessTokenExpired()) return true;

  // 如果 refresh token 未过期，也认为已登录（可以刷新 token）
  if (!isRefreshTokenExpired()) return true;

  return false;
}

/**
 * 清除所有登录信息
 */
export function clearAuthData() {
  Object.values(TOKEN_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
}

/**
 * 保存用户 ID
 * @param {string} userId - 用户 ID
 */
export function saveUserId(userId) {
  localStorage.setItem(TOKEN_KEYS.USER_ID, userId);
}

/**
 * 获取用户 ID
 * @returns {string|null} 用户 ID
 */
export function getUserId() {
  return localStorage.getItem(TOKEN_KEYS.USER_ID);
}

/**
 * 保存用户污点状态
 * @param {boolean} isTainted - 是否为污点用户
 */
export function saveIsTainted(isTainted) {
  localStorage.setItem(TOKEN_KEYS.IS_TAINTED, isTainted ? 'true' : 'false');
}

/**
 * 获取用户污点状态
 * @returns {boolean} 是否为污点用户
 */
export function getIsTainted() {
  return localStorage.getItem(TOKEN_KEYS.IS_TAINTED) === 'true';
}

/**
 * 清除用户污点状态
 */
export function clearIsTainted() {
  localStorage.removeItem(TOKEN_KEYS.IS_TAINTED);
}
